import React from 'react'
import { connect } from 'react-redux'
import { Button } from 'reactstrap'
import { FormattedHTMLMessage } from 'react-intl'
import { claimActions } from '../../../redux/actions'
import FormattedMessage from '../../../components/FormattedMessage/FormattedMessage'
import NoMoreCreditsModal from '../../../components/Modal/NoMoreCreditsModal/NoMoreCreditsModal'

import ImageUrlUtil from '../../../utilities/boxImageUrlFormatter'

class SelectContent extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      modalOpen: false,
    }
  }

  _toggleModal = () => {
    this.setState({
      modalOpen: !this.state.modalOpen,
    })
  }

  _selectContent = content => {
    const { currentCreditsUsed, maximumSelections } = this.props
    if (currentCreditsUsed + content.credits > maximumSelections) {
      // Fire a modal if there are no more available credits
      this._toggleModal()
    } else {
      this.props.selectContent(this.props.activePromotionStepId, content)
    }
  }

  _renderSelectedContentButton = (isContentSelected, isContentRedeemed, activeContent) => {
    if (isContentSelected) {
      return (
        <Button type="submit" outline color="dark" size="sm" block disabled aria-disabled="true">
          <FormattedMessage id="global.label.selected" />
        </Button>
      )
    }
    if (isContentRedeemed) {
      return (
        <Button type="submit" outline color="dark" size="sm" block disabled aria-disabled="true">
          <FormattedMessage id="global.label.redeemed" />
        </Button>
      )
    }
    return (
      <Button
        type="submit"
        outline
        color="dark"
        size="sm"
        block
        onClick={() => this._selectContent(activeContent)}
        aria-label={
          this.props.intl?.formatMessage
            ? this.props.intl.formatMessage({ id: 'global.label.addCart' })
            : 'Add to cart'
        }
      >
        <FormattedMessage id="global.label.addCart" />
      </Button>
    )
  }

  _buildActiveContentImageSrc = () => {
    const { activeContent } = this.props
    const activeContentImageSrc = activeContent && activeContent.imageUrl

    // fallback to old way if image src is undefined
    if (!activeContentImageSrc) return activeContent.content.boxImgName
    return ImageUrlUtil(activeContentImageSrc)
  }

  render() {
    const { modalOpen } = this.state
    const { activeContent, currentContentList, redeemedContent } = this.props
    const isContentSelected =
      activeContent &&
      currentContentList.selectedContent &&
      currentContentList.selectedContent.reduce(
        (selected, content) => selected || content.id === activeContent.id,
        false
      )
    const isContentRedeemed =
      activeContent &&
      redeemedContent &&
      redeemedContent.reduce(
        (redeemed, content) => redeemed || content.contentId === activeContent.id,
        false
      )
    return (
      <div
        className="col-12 col-md-8 select-credits-details-container mt-4 mt-md-0"
        aria-labelledby="active-content-heading"
      >
        <NoMoreCreditsModal isOpen={modalOpen} toggle={this._toggleModal} />
        {activeContent && (
          <div className="col">
            <div className="row">
              <div className="col-12 col-sm-auto select-img-container">
                <div>
                  <img
                    className="select-credits-box-art"
                    src={this._buildActiveContentImageSrc()}
                    alt={`${activeContent.content.name}`}
                  />
                </div>
              </div>
              <div className="col">
                <h4 id="active-content-heading">{activeContent.content.name}</h4>
                <p className="tags">
                  <FormattedMessage
                    id="global.label.contentCredits"
                    values={{ credits: activeContent.credits }}
                  />
                </p>
                <p className="tags">
                  <FormattedMessage
                    id="global.label.releaseDate"
                    values={{
                      date: activeContent.content.releaseDate
                        ? activeContent.content.releaseDate
                        : 'TBD',
                    }}
                  />
                </p>
                <p className="tags">
                  <FormattedMessage id="global.general.releaseDateDisclaimer" />
                </p>
                <p
                  className="mt-4"
                  dangerouslySetInnerHTML={{ __html: activeContent.content.description }}
                />
                {activeContent.content.url.trim() && (
                  <p className="info">
                    <a href={activeContent.content.url} target="_blank" rel="noreferrer">
                      <FormattedMessage id="page.redemptionPage.text.moreInfo" />
                    </a>
                  </p>
                )}
              </div>
            </div>
            <div className="my-3">
              <div className="d-flex flex-wrap">
                {activeContent.content.contentRatings.map((ratings, index) => (
                  <div key={ratings.rating.id} className="d-flex">
                    <img
                      src={ratings.rating.fileName}
                      key={ratings.rating.name}
                      alt={ratings.rating.name}
                      className={`mb-3 img-fluid contentItem-page__ratingImg ${
                        index === 0 ? 'mr-1' : 'mx-1'
                      }`}
                    />
                  </div>
                ))}
              </div>
              <p className="legal-tags m-0">{activeContent.legalAttributeTitle}</p>
              <p className="legal-tags m-0">{activeContent.legalAttributeDescription}</p>
              <p className="legal-tags m-0">
                <span dangerouslySetInnerHTML={{ __html: activeContent.legalAttributeUrl }} />
              </p>
              <p className="legal-tags m-0">
                <FormattedMessage
                  id={`contentProvider.${activeContent.content.content_provider.name}.legalAttribute.title`}
                />
              </p>
              <p className="legal-tags m-0">
                <FormattedMessage
                  id={`contentProvider.${activeContent.content.content_provider.name}.legalAttribute.description`}
                />
              </p>
              <p className="legal-tags m-0">
                <FormattedHTMLMessage
                  id={`contentProvider.${activeContent.content.content_provider.name}.legalAttribute.url`}
                />
              </p>
            </div>
            <div className="row">
              {this._renderSelectedContentButton(
                isContentSelected,
                isContentRedeemed,
                activeContent
              )}
            </div>
          </div>
        )}
      </div>
    )
  }
}

const mapStateToProps = state => ({
  activePromotionStepId: state.claimReducers.activePromotionStepId,
})

const mapDispatchToProps = dispatch => ({
  selectContent: (...args) => dispatch(claimActions.selectContent(...args)),
})

export default connect(mapStateToProps, mapDispatchToProps)(SelectContent)
